import React from 'react';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Partials/Modal';
import {InputField, Label, FileUpload, Select, TextArea, Button} from 'Components/Partials/Form';
import {Alert} from 'Components/Partials/Layouts';
import Base from 'Components/Base/Base';

import SupportApi from 'Services/Api/Support/Support';

import version from 'Config/version';

export default class Support extends Base {
    /**
     * @var state
     */
    state = {
        form: {
            type: null,
            name: this.props.user !== null ? `${this.props.user.first_name} ${this.props.user.last_name}` : '',
            email: this.props.user?.email ?? '',
            number: this.props.user?.info?.personal_number ?? 'N/A',
            message: '',
            version,
            file: null,
            path: window.location.pathname
        },
        working: false,
        alert: null,
    };

    /**
     * @var types
     */
    types = [
        {value: 'question', label: 'I have a question'},
        {value: 'bug', label: 'I found a bug'},
        {value: 'suggestion', label: 'I have a suggestion'},
    ];

    /**
     * @method handleSubmit
     * @param {Event} e
     */
    handleSubmit = async (e) => {
        e.preventDefault();
        this.working();
        const {form} = this.state;

        const request = await SupportApi.send({
            ...form,
            type: form.type?.value
        });

        if (request.status !== 200) {
            return this.formErrors(request.message, request.errors);
        }

        this.toastSuccess('Your support request has been sent!');
        this.props.onClose();
    };

    /**
     * @method render
     */
    render() {
        const {form, working, alert} = this.state;

        return (
            <Modal>
                <ModalHeader onClose={this.props.onClose}>
                    Create Support Request
                </ModalHeader>

                <form onSubmit={this.handleSubmit}>
                    <ModalBody>
                        {alert !== null && (<Alert {...alert} />)}

                        <div className="mb-4">
                            <Label htmlFor="number" label="Name"/>
                            <InputField
                                id="name"
                                value={form.name}
                                onChange={e => this.handleFormInput('name', e.target.value)}
                            />
                        </div>

                        <div className="mb-4">
                            <Label htmlFor="number" label="Email"/>
                            <InputField
                                type="email"
                                id="email"
                                value={form.email}
                                onChange={e => this.handleFormInput('email', e.target.value)}
                            />
                        </div>

                        <div className="mb-4">
                            <Label htmlFor="number" label="Contact Number"/>
                            <InputField
                                id="number"
                                value={form.number}
                                onChange={e => this.handleFormInput('number', e.target.value)}
                            />
                        </div>

                        <div className="mb-4">
                            <Label htmlFor="number" label="Subject"/>
                            <Select
                                options={this.types}
                                value={form.type}
                                onChange={option => this.handleFormInput('type', option)}
                            />
                        </div>

                        <div className="mb-4">
                            <Label htmlFor="number" label="Message"/>
                            <TextArea
                                value={form.message}
                                onChange={e => this.handleFormInput('message', e.target.value)}
                            />
                        </div>

                        <div>
                            <Label htmlFor="number" label="File"/>
                            <FileUpload
                                onChange={file => this.handleFormInput('file', file)}
                            />
                        </div>

                        {form.type?.value === 'bug' && (
                            <p className="mt-4 text-sm">
                                Please consider attaching a screenshot to highlight the problem you're experiencing. It
                                would help tremendously :)
                            </p>
                        )}
                    </ModalBody>

                    <ModalFooter alignment="center">
                        <Button working={working}>
                            Send
                        </Button>
                    </ModalFooter>
                </form>
            </Modal>
        );
    }
}
